import { PlaceOrderQueryModel } from "@affinity/Store/PrePopulation";

export type QueryStringState = Readonly<{
    PlaceOrderQueryString: PlaceOrderQueryModel;
    // TODO: Add additional query string models, named by destination page
}>;

export const initialState: QueryStringState = {
    PlaceOrderQueryString: {
        page: "placeorder"
    },
};

export default QueryStringState;